import { useEffect, useState, useContext } from 'react'
import { Location } from 'history'
import { injectJs } from '@chilipiper/service/src/inject-js'
import { parseQuery, getDomain } from '@chilipiper/utils'
import { setTag } from '@chilipiper/sentry'
import { IntercomData } from './types'
import { bookingContext } from './context/bookingContext'

interface Query {
  [key: string]: string
}

const getIntercomData = (queryParams: Query) => {
  if (queryParams?.intercom_session) {
    injectJs('https://s3.amazonaws.com/intercom-sheets.com/messenger-sheet-library.latest.js')
    const {
      intercom_assigneeId,
      intercom_prospectName,
      intercom_prospectEmail,
      intercom_prospectPhone,
      intercom_timezone,
      intercom_templateId,
      intercom_templateDuration,
    } = queryParams
    const userName = intercom_prospectName
      ? decodeURIComponent(intercom_prospectName).split(' ')
      : []
    const email = intercom_prospectEmail ? decodeURIComponent(intercom_prospectEmail) : undefined
    const phone = intercom_prospectPhone ? decodeURIComponent(intercom_prospectPhone) : undefined
    const timezone = intercom_timezone ? decodeURIComponent(intercom_timezone) : undefined
    const template = intercom_templateId || undefined
    const duration = intercom_templateDuration ? parseInt(intercom_templateDuration, 10) : undefined
    return {
      timezone: timezone,
      assigneeId: intercom_assigneeId,
      queueId: intercom_assigneeId,
      firstName: userName[0],
      lastName: userName.slice(1).join(' '),
      name: userName.join(' '),
      email: email,
      phone: phone,
      template: template,
      duration: duration,
    } as IntercomData
  }
  return null
}

export const useQueryParams = (location?: Location) => {
  const [, setRescheduleId] = useState('')
  const [routeId, setRouteId] = useState('')
  const [tenantDomain, setTenantDomain] = useState('')
  const [isIntermediate, setIsIntermediate] = useState(false)
  const [footer, setFooter] = useState(false)
  const [marketing, setMarketing] = useState(false)
  const [processRedirect, setProcessRedirect] = useState('')
  const [seriesId, setSeriesId] = useState('')
  const [closeRedirect, setCloseRedirect] = useState<string | undefined>()
  const [hideCloseButton, setHideCloseButton] = useState(false) // hide_x
  const [intercomData, setIntercomData] = useState<IntercomData | null>(null)
  const { bookingState: { organizationName = '' } = {} } = useContext(bookingContext)
  useEffect(() => {
    const query = parseQuery() as Query
    setTag('module', 'online-calendar')
    const data = getIntercomData(query)
    const singleUseLinkDomain = new URLSearchParams(
      (location?.state as { search: string })?.search
    ).get('domain')
    const domain = singleUseLinkDomain || query.domain || getDomain()
    setIntercomData(data)
    setRescheduleId(query.rescheduleId || '')
    setTenantDomain(domain)
    setRouteId(query.routeId)
    setHideCloseButton(query.hide_x === 'true')
    setFooter(query.footer !== 'false')
    setProcessRedirect(decodeURIComponent(query.processRedirect || ''))
    setCloseRedirect(query.closeRedirect && decodeURIComponent(query.closeRedirect))
    setMarketing(query.marketing === 'true')
    setSeriesId(query.seriesId)
    setIsIntermediate(Boolean(query.withPhone || query.withVideo))
  }, [organizationName])
  return {
    isIntermediate,
    footer,
    marketing,
    intercomData,
    processRedirect,
    setCloseRedirect,
    routeId,
    closeRedirect,
    seriesId,
    hideCloseButton,
    setHideCloseButton,
    tenantDomain,
  }
}
